// Global toast service - can be used from anywhere in the app
class ToastService {
  constructor() {
    this.toastHandlers = [];
  }

  // Register a toast handler (called by components that can show toasts)
  registerHandler(handler) {
    this.toastHandlers.push(handler);
  }

  // Unregister a toast handler
  unregisterHandler(handler) {
    this.toastHandlers = this.toastHandlers.filter(h => h !== handler);
  }

  // Show toast from anywhere in the app
  showToast(message, severity = 'info', duration = 4000) {
    console.log('🍞 [TOAST] Showing toast:', { message, severity, duration });
    
    // Call all registered handlers
    this.toastHandlers.forEach(handler => {
      try {
        handler(message, severity, duration);
      } catch (error) {
        console.error('Error calling toast handler:', error);
      }
    });
  }

  // Convenience methods
  success(message, duration = 4000) {
    this.showToast(message, 'success', duration);
  }

  error(message, duration = 6000) {
    this.showToast(message, 'error', duration);
  }

  warning(message, duration = 5000) {
    this.showToast(message, 'warning', duration);
  }

  info(message, duration = 4000) {
    this.showToast(message, 'info', duration);
  }
}

// Create singleton instance
const toastService = new ToastService();

export default toastService;
